import { render, staticRenderFns } from "./SaltoComprobanteDrawer.vue?vue&type=template&id=08d9f41b&scoped=true&"
import script from "./SaltoComprobanteDrawer.vue?vue&type=script&lang=js&"
export * from "./SaltoComprobanteDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SaltoComprobanteDrawer.vue?vue&type=style&index=0&id=08d9f41b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d9f41b",
  null
  
)

export default component.exports